<template>
    <div class="settlement-statement">
        <div class="content-box income first">
            <RingDiagram :data-source="ringData"></RingDiagram>
            <div class="info">
                <div class="name">
                    版权总收益
                    <Amount :value="income.totalAmount.toLocaleString('zh', {minimumFractionDigits: 2})"></Amount>
                </div>
                <div class="statistics">
                    <p>
                        待提现：
                        <Amount size="samll" :value="income.withdrawableTotalAmount.toLocaleString('zh', {minimumFractionDigits: 2})"></Amount>
                    </p>
                    <p>
                        已提现：
                        <Amount size="samll" :value="income.withdrawTotalAmount.toLocaleString('zh', {minimumFractionDigits: 2})"></Amount>
                    </p>
                </div>
            </div>
        </div>
        <div class="content-box">
            <div class="title">合同结算数据</div>
            <div class="page-list-box">
                <el-table v-loading="loading" :data="billList" style="width: 100%">
                    <el-table-column prop="timeStr" width="220" label="时间"></el-table-column>
                    <el-table-column label="报表收入">
                        <template slot-scope="scope">{{ scope.row.amount }} {{ scope.row.currency }}</template>
                    </el-table-column>
                    <el-table-column label="可提现金额">
                        <template slot-scope="scope">{{ scope.row.withdrawableAmount }} {{ scope.row.currency }}</template>
                    </el-table-column>
                    <!-- <el-table-column label="状态">
                        <template slot-scope="scope">
                            <p v-if="scope.row.status == 4">已提现</p>
                            <p v-else>未提现</p>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <!-- 子系统版税单 -->
                            <template v-if="scope.row.type == 1">
                                <p v-if="scope.row.status == 3">未提现</p>
                                <p v-else-if="scope.row.status == 4">已提现</p>
                                <p v-else>--</p>
                            </template>
                            <!-- dmh版税单 -->
                            <template v-else-if="scope.row.type == 2">
                                <p v-if="scope.row.status == 2">未提现</p>
                                <p v-else-if="scope.row.status == 3">已提现</p>
                                <p v-else>--</p>
                            </template>
                            <p v-else>未提现</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <!-- 子系统版税单 -->
                            <template v-if="scope.row.type == 1">
                                <el-button @click="$router.push(`/manage/settlement/detail/${scope.row.id}`)" type="text">查看详情</el-button>
                            </template>
                            <!-- dmh版税单 -->
                            <template v-else-if="scope.row.type == 2">
                                <el-button @click="$router.push(`/manage/settlement/dmhDetail/${scope.row.id}`)" type="text">查看详情</el-button>
                            </template>
                            <p v-else>--</p>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import Big from 'big.js';
Big.DP = 2;
import RingDiagram from '../components/RingDiagram';
const defaultQuery = {
    cpId: ''
};
export default {
    components: {RingDiagram},
    data() {
        return {
            filterData: {...defaultQuery},
            tabsName: '1',
            loading: false,
            billList: [],
            income: {
                totalAmount: 0,
                withdrawTotalAmount: 0,
                withdrawableTotalAmount: 0,
                withdrawComplete: 1,
                withdrawWait: 0,
            },
            ringData: [],
        };
    },
    created() {
        this.revenueStatistics();
        this.fetchBill();
    },
    methods: {
        async revenueStatistics() {
            const response = await this.$request({
                url: '/cp-income/view/settlement-sta',
                method: 'POST',
            });
            const {msg, state, result} = response.data;
            if (!state) return this.$message.error(msg || '');
            let withdrawComplete = 0;
            let withdrawWait = 0;
            if (result.totalAmount == 0) {
                withdrawComplete = 1;
                withdrawWait = 0;
            } else {
                withdrawWait = Big(result.withdrawableTotalAmount).div(result.totalAmount).toNumber();
                withdrawComplete = Big(result.withdrawTotalAmount).div(result.totalAmount).toNumber();
            }
            this.income = {
                ...result,
                ...{
                    withdrawComplete: Big(withdrawComplete).times(100).toNumber(),
                    withdrawWait: Big(withdrawWait).times(100).toNumber(),
                },
            };
            this.ringData = [{ratio: withdrawWait}, {active: true, ratio: Math.abs(withdrawComplete)}];
        },
        async fetchBill() {
            this.loading = true;
            this.filterData.cpId = this.$store.state.userInfo.id;
            const response = await this.$request({
                url: '/cp-income/view/settlement-list',
                method: 'POST',
                data: this.filterData,
                formData: false,
            });
            const {msg, state, result} = response.data;
            this.loading = false;
            if (!state) return this.$message.error(msg || '');
            this.billList = result.result;
        },
    },
};
</script>
<style lang="scss">
.settlement-statement {
    .content-box {
        padding: 40px;
    }

    .income {
        display: flex;
        padding: 64px 40px !important;
        align-items: center;

        .info {
            margin-left: 40px;
            flex: 1;
            color: $-text-500;

            .name {
                font-size: 14px;
                font-weight: 400;
                line-height: 14px;
                margin-bottom: 30px;

                .amount {
                    display: inline-block;
                    margin-left: 10px;
                }
            }

            .statistics {
                display: flex;

                p {
                    flex: 1;
                    display: flex;
                    align-items: center;

                    &::before {
                        content: '';
                        width: 14px;
                        height: 14px;
                        border-radius: 2px;
                        display: block;
                        margin-right: 10px;
                        top: 1px;
                        position: relative;
                    }

                    &:nth-child(1)::before {
                        background: #8587ff;
                    }

                    &:nth-child(2)::before {
                        background: #d4d1ff;
                    }
                }
            }
        }
    }
}
</style>
